/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-useless-computed-key */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import CheckBox from "components/Form/CheckBox";
import InputField from "components/Form/InputField";
import DialogComponent, { ContentTextArea, DialogConfirm, DialogRejected, TextArea2 } from 'components/Dialog';
import { LostCancelButton } from 'components/index';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Title, ButtonContent } from "./styles";
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";

export default function SendPolicyPackInsurer(props) {
  const [idProduct, setIdProduct] = useState(null);
  const [summary, setSummary] = useState({});
  const [userComments, setUserComments] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [insurers, setInsurers] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [typeDialog, setTypeDialog] = useState(null);
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });
  const [isBound, setIsBound] = useState(false);

  const formik = useRef(null);
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const isClient = authContext.enumProfile === 1 ? true : false;

  const endorsmentTypeEnum = {
    ['not-pre-agreed']: {
      title: 'Anniversary - Premium: Not Pre Agreed / Send Policy Pack - Insurer'
    },
    ['cancellation']: {
      title: 'Endorsement - Cancellation / Send Policy Pack - Insurer'
    }
  }

  const validation = () => {

    if (selectedItems.length >= 1) {
      return true;
    }
    else {
      return false;
    }
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        console.log("Sumario-> ", data.ret_value)
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          idOperation: props.match.params.idOperation,
        });
        setEndorsmentType(data.ret_value.endorsmentType);
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
    loading.stop();
  };

  function handleSendApproval() {
    let valid = validation();

    if (valid !== true) {
      mc.error('Please fill in all required fields.');
      return
    }

    fitinsur.setAuthToken(authContext.token);
    let body = {
      idOperation: props.match.params.idOperation,
      policyPackMessage: formik.current.values.policyPackMessage,
      insurers: []
    };

    insurers.forEach(x => {
      body.insurers.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedItems.forEach(x => {
      let i = body.insurers.findIndex(e => e.idPersonInsurer == x.idPersonInsurer);
      if (i != -1) {
        body.insurers[i].contacts.push({ idContact: x.idContact, email: x.email });
      }
    })

    fitinsur.requestSentInsurerPolicyPack(body)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        if (endorsmentType && endorsmentType !== "declaration") {
          return history.push('/policies');
        } else {
          return history.push('/list');
        }
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  const handleEnable = () => {
    fitinsur.setAuthToken(authContext.token);

    fitinsur.wordingAttachments(props.match.params.idOperation).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
    });
  }

  function handleSelect(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== contact.email);
      setSelectedItems(filteredItems);
    } else {
      let list = [...selectedItems];
      list.push(contact);
      setSelectedItems([...list]);
      console.log("list de contactos", selectedItems);
    };
  };

  function listContacts(idContactDepartment) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);

    fitinsur.requestListContactsByType(props.match.params.idOperation, 'insurer', idContactDepartment)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          loading.stop();
          return;
        }
        setInsurers(data.ret_value);
        loading.stop();
      }).catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
        loading.stop();
      });
  };

  const listItems = insurers.length ? insurers.map((insurer) => (
    <>
      <Title>TO</Title>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {insurer.insurerFirstName}
        </Title>
      </Row>

      {
        insurer.contacts.length ? insurer.contacts.map((contact) => (
          <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
            <Col style={{ flexDirection: "row", display: "flex" }}>
              <label>
                <CheckBox
                  onChange={() => { handleSelect(contact, insurer) }}
                  checked={selectedItems.find((item) => item.email === contact.email) ? true : false}
                  disabled={isBound}
                />
              </label>
              <Label>
                {contact.legalEntity}
              </Label>
            </Col>
            <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
              <Label>{contact.nameContact}</Label>
            </Col>
            <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
              <Label>{contact.personContactDepartment}</Label>
            </Col>
            <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
              <Label>{contact.email}</Label>
            </Col>
          </Row>
        )) : (
          <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
            <Label>
              No results found.
            </Label>
          </Row>
        )
      }
    </>
  )) : (
    <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Label>
        No results found.
      </Label>
    </Row>
  )

  function handleCancel() {
    setUserComments("");
    setDialog({
      visible: false,
      title: '',
      icon: 'exclamation',
      args: null
    })
  }

  function handleApproval() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingBrokerSrApprove(props.match.params.idOperation, userComments)
      .then(response => response.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          history.push('/list');

        } else {
          mc.error(resp.ret_msg_details);
          loading.stop();
        }
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostAproval - Error:', error);
        loading.stop();
      });

  };

  function handleReject() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.wordingBrokerSrReject(props.match.params.idOperation, userComments)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code === 200) {
          loading.stop();
          mc.success("Approval Order To Bind Rejected");
          history.push('/list');
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  async function handleOperationInfo() {
    loading.start()
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationInfo(props.match.params.idOperation)
      .then(response => response.json())
      .then(response => {
        setIsBound(response?.isBound);
        setIdProduct(response?.isDeclaration ? response?.idProduct : 12);
        loading.stop();
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleReject.name}\n` + error);
        loading.stop();
      });
  }

  useEffect(() => { 
    if(idProduct == 12) { 
      history.push(`/broking/send-approval-pack/${props.match.params.idOperation}`)
    } else if(idProduct == 16) { 
      history.push(`/broking/send-approval-pack-declaration/${props.match.params.idOperation}`)
    }
  }, [idProduct])
  
  useEffect(() => {
    loading.start();
    if (authContext.status !== true) {
      mc.error("Usuário não autenticado");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };
    handleOperationInfo();
    handleSummary();
    handleEnable();
    listContacts();

  }, [])

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.nmObligor
        ? summary.nmObligor
        : "Broking name"
      }
      subtitle={summary.dealCode
        ? summary.dealCode
        : "Broking code"
      }
    >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />

      <DialogComponent icon={dialog.icon} title={dialog.title}  show={dialog.visible} setDialog={setDialog}>
        {typeDialog === 'Approve' ?
          <ContentTextArea>
            <p>Deal Analysis information</p>
            <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
            <DialogRejected onClick={() => handleCancel()}>CANCEL</DialogRejected>
            <DialogConfirm onClick={() => handleApproval()}>CONFIRM</DialogConfirm>
          </ContentTextArea>

          : typeDialog === 'Reject' ?
            <ContentTextArea>
              <p>Deal Analysis information</p>
              <TextArea2 value={userComments} onChange={(e) => setUserComments(e.target.value)}></TextArea2>
              <DialogRejected type="submit" onClick={() => handleCancel()}>CANCEL</DialogRejected>
              <DialogConfirm type="submit" onClick={() => handleReject()}>CONFIRM</DialogConfirm>
            </ContentTextArea>
            : ''
        }
      </DialogComponent>

      <ContentCard
        title={endorsmentTypeEnum[endorsmentType]
          ? endorsmentTypeEnum[endorsmentType].title
          : isClient
            ? 'Client'
            : 'Send Policy Pack - Insurer'
        }
        icon
        info={{
          idOperation: props.match?.params?.idOperation || null,
          idProduct: props.location?.state?.idProduct || null
        }}
        filterContact
        handleFilterContact={(idContactDepartment) => listContacts(idContactDepartment)}
      >
        <Formik
          innerRef={formik}
          initialValues={{}}
          onSubmit={handleSendApproval}
        >
          {formikProps => (
            <Form>
              {isClient
                ? ''
                : listItems
              }
              <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                <Title>
                  CC
                </Title>
              </Row>
              <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
                <Col sm={6}>
                  <Field
                    name={'cc'}
                    value={formikProps.values.policyPackMessage}
                    onChange={(e) => formikProps?.setFieldValue('cc', e)}
                    component={InputField}
                    disabled={isBound}
                  />
                </Col>
              </Row>
              <Field
                label={'Policy Pack Message - (External)'}
                name={'policyPackMessage'}
                value={formikProps.values.policyPackMessage}
                onChange={(e) => formikProps?.setFieldValue('policyPackMessage', e)}
                component={TextField}
              />

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <HasPermission permission={!isBound}>
                  <RenderButtons idOperation={props.match?.params?.idOperation}>
                    <ButtonContent>
                      <div style={{ marginTop: "5px" }}>
                        <LostCancelButton idOperation={props.match?.params?.idOperation} />
                      </div>
                      <HasPermission permission={props.permissions.POLICY_PACK_SEND_INSURER || props.permissions.ENDORSEMENT_PACK_SEND_INSURER}>
                        <Button
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          primary
                          type="submit"
                          id="btnSubmit"
                        >
                          SEND POLICY PACK
                        </Button>
                      </HasPermission>
                    </ButtonContent>
                  </RenderButtons>
                </HasPermission>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}